import estilos from './LoaderMega.module.css'

/**
 * Trazados oficiales de la marca MEGA Distribuciones y Proyectos S.A.S.
 * Filos matemáticos puros sin distorsión.
 */
const TRAZO_MORADO =
  'M211.97,366.65L209.16,365.81L191.13,336.47L176.85,308.49L108.67,190.78L75.48,130.00L74.83,126.31' +
  'L85.25,124.81L221.25,124.69L263.48,92.00L261.94,97.99L226.51,158.38L173.68,257.44L176.42,261.23' +
  'L261.29,260.31L265.82,262.03L264.17,268.07L242.04,308.08L217.99,359.25Z'

const TRAZO_AMARILLO =
  'M241.74,432.41L238.25,429.59L234.17,418.89L226.42,407.98L218.58,402.97L200.83,401.82L199.50,398.75' +
  'L200.83,394.01L212.21,381.14L217.99,371.36L228.93,361.70L267.20,317.76L328.51,242.25L334.83,231.42' +
  'L333.24,228.17L330.58,227.52L251.75,227.89L240.16,226.99L233.81,223.88L233.01,214.75L235.18,202.42' +
  'L244.67,169.75L253.38,130.75L258.02,126.11L260.92,125.48L384.35,128.33L428.63,130.99L429.00,133.95' +
  'L426.35,139.30L406.52,168.12L364.66,239.08L357.35,248.19L315.45,316.08L305.18,329.79L250.13,419.70' +
  'L246.48,427.97Z'

/**
 * Resuelve el mensaje canónico de 3 palabras según la ruta que el usuario está visitando.
 * Cumple: 3 palabras, MAYÚSCULAS, termina en "...", contexto eléctrico serio y certero.
 */
export function mensajePorRuta(pathname?: string): string {
  const ruta = (pathname ?? (typeof window !== 'undefined' ? window.location.pathname : ''))
    .toLowerCase()
    .replace(/\/$/, '') || '/'

  if (ruta === '/ingresar') return 'AUTENTICANDO ACCESO SEGURO...'
  if (ruta === '/' || ruta === '/tablero') return 'CALCULANDO INDICADORES CLAVE...'
  if (ruta.startsWith('/mi-trabajo')) return 'CARGANDO TRABAJO ACTIVO...'
  if (ruta.startsWith('/mi-programacion')) return 'SINCRONIZANDO PROGRAMACIÓN TÉCNICA...'
  if (ruta.startsWith('/mi-historial')) return 'CONSULTANDO HISTORIAL TÉCNICO...'
  if (ruta.startsWith('/ordenes/') && ruta !== '/ordenes') return 'CARGANDO DETALLE ORDEN...'
  if (ruta.startsWith('/ordenes')) return 'PROCESANDO ÓRDENES SERVICIO...'
  if (ruta.startsWith('/chatbot')) return 'CONECTANDO ASISTENTE VIRTUAL...'
  if (ruta.startsWith('/herramientas')) return 'INSPECCIONANDO HERRAMIENTAS TRABAJO...'
  if (ruta.startsWith('/servicios-finalizados')) return 'CONSULTANDO SERVICIOS FINALIZADOS...'
  if (ruta.startsWith('/clientes')) return 'CONSULTANDO CLIENTES ACTIVOS...'
  if (ruta.startsWith('/cotizador') || (ruta.startsWith('/cotizaciones/') && ruta !== '/cotizaciones')) {
    return 'GENERANDO DOCUMENTO COTIZACIÓN...'
  }
  if (ruta.startsWith('/cotizaciones')) return 'CALIBRANDO MATRIZ COTIZACIONES...'
  if (ruta.startsWith('/financiera/cartera') || ruta.startsWith('/cartera')) {
    return 'BALANCEANDO CARTERA PENDIENTE...'
  }
  if (ruta.startsWith('/facturas')) return 'PROCESANDO FACTURAS VENTA...'
  if (ruta.startsWith('/bodega/alistamientos') || ruta.startsWith('/alistamientos')) {
    return 'ALISTANDO CIRCUITOS PENDIENTES...'
  }
  if (ruta.startsWith('/inventario')) return 'VERIFICANDO EXISTENCIAS BODEGA...'
  if (ruta.startsWith('/sobrantes')) return 'VERIFICANDO SOBRANTES DISPONIBLES...'
  if (ruta.startsWith('/maestros/bodega')) return 'UBICANDO BODEGA PRINCIPAL...'
  if (ruta.startsWith('/maestros/colaboradores')) return 'SINCRONIZANDO PERSONAL ACTIVO...'
  if (ruta.startsWith('/auditoria')) return 'CONSULTANDO BITÁCORA CENTRAL...'
  if (ruta.startsWith('/compras')) return 'CALCULANDO SUMINISTROS FALTANTES...'
  if (ruta.startsWith('/etiquetas')) return 'IMPRIMIENDO ETIQUETAS CIRCUITOS...'

  return 'ENERGIZANDO RED ELÉCTRICA...'
}

/**
 * Normaliza cualquier texto para garantizar:
 * 1) Exactamente 3 palabras
 * 2) MAYÚSCULAS sostenidas
 * 3) Terminación obligatoria en "..."
 * 4) Contexto eléctrico real sin mensajes engañosos de carga finalizada
 */
export function normalizarTresPalabras(texto?: string, ruta?: string): string {
  if (!texto || !texto.trim() || texto.trim().toLowerCase() === 'cargando…' || texto.trim().toLowerCase() === 'cargando...') {
    return mensajePorRuta(ruta)
  }

  const limpio = texto
    .trim()
    .replace(/[.…]+$/, '')
    .toUpperCase()

  // Mapeos canónicos por frase conocida
  const equivalencias: Array<[string, string]> = [
    ['ABRIENDO EL ARCHIVO', 'CONSULTANDO ARCHIVO CENTRAL'],
    ['ABRIENDO EL BORRADOR', 'ABRIENDO BORRADOR COTIZACIÓN'],
    ['ABRIENDO', 'INICIANDO SISTEMA CENTRAL'],
    ['VERIFICANDO LA SESI', 'AUTENTICANDO ACCESO SEGURO'],
    ['LEYENDO LA BIT', 'CONSULTANDO BITÁCORA CENTRAL'],
    ['BUSCANDO LO QUE HAY', 'ALISTANDO CIRCUITOS PENDIENTES'],
    ['BUSCANDO LO QUE FALTA', 'CALCULANDO SUMINISTROS FALTANTES'],
    ['CARGANDO CLIENTES', 'CONSULTANDO CLIENTES ACTIVOS'],
    ['CARGANDO SU HISTORIAL', 'CONSULTANDO HISTORIAL TÉCNICO'],
    ['CARGANDO SU PROGRAMACI', 'SINCRONIZANDO PROGRAMACIÓN TÉCNICA'],
    ['BUSCANDO SU TRABAJO', 'CARGANDO TRABAJO ACTIVO'],
    ['CONTANDO LOS SOBRANTES', 'VERIFICANDO SOBRANTES DISPONIBLES'],
    ['TRAYENDO LOS MOVIMIENTOS', 'CONSULTANDO MOVIMIENTOS RECIENTES'],
    ['CARGANDO EL INVENTARIO', 'VERIFICANDO EXISTENCIAS BODEGA'],
    ['CARGANDO FACTURAS', 'PROCESANDO FACTURAS VENTA'],
    ['CARGANDO RENGLONES', 'PROCESANDO RENGLONES FACTURA'],
    ['SACANDO LA CARTERA', 'BALANCEANDO CARTERA PENDIENTE'],
    ['PREPARANDO LAS ETIQUETAS', 'IMPRIMIENDO ETIQUETAS CIRCUITOS'],
    ['ARMANDO EL DOCUMENTO', 'GENERANDO DOCUMENTO TÉCNICO'],
    ['ARMANDO LA FACTURA', 'GENERANDO FACTURA VENTA'],
    ['CARGANDO COTIZACIONES', 'CALIBRANDO MATRIZ COTIZACIONES'],
    ['CARGANDO LOS CONCEPTOS', 'PROCESANDO CONCEPTOS COTIZACIÓN'],
    ['CARGANDO LA MATRIZ', 'PROCESANDO ÓRDENES SERVICIO'],
    ['CARGANDO LA ORDEN', 'CARGANDO DETALLE ORDEN'],
    ['CARGANDO LA HISTORIA', 'CONSULTANDO HISTORIAL TÉCNICO'],
    ['CALCULANDO', 'CALCULANDO INDICADORES CLAVE'],
    ['MIDIENDO', 'CALIBRANDO RENDIMIENTO TÉCNICO'],
  ]

  for (const [clave, reemplazo] of equivalencias) {
    if (limpio.includes(clave)) {
      return `${reemplazo}...`
    }
  }

  // Si ya tiene palabras, calibrar a exactamente 3
  const palabras = limpio.split(/\s+/).filter(Boolean)
  if (palabras.length === 3) {
    return `${palabras.join(' ')}...`
  }
  if (palabras.length > 3) {
    return `${palabras.slice(0, 3).join(' ')}...`
  }
  if (palabras.length === 2) {
    return `${palabras[0]} ${palabras[1]} ACTIVOS...`
  }
  if (palabras.length === 1) {
    return `${palabras[0]} RED ELÉCTRICA...`
  }

  return mensajePorRuta(ruta)
}

export type PropsLoaderMega = {
  /** Mensaje de carga (se formatea a exactamente 3 palabras en mayúscula con '...'). */
  mensaje?: string
  /** Ocupa toda la pantalla con centrado absoluto horizontal y vertical. */
  pantallaCompleta?: boolean
  /** Para bloques internos compactos (tarjetas, modales pequeños). */
  compacto?: boolean
  /** Ruta opcional para derivar el mensaje si no se provee. */
  ruta?: string
  className?: string
}

/**
 * Loader institucional con el isotipo oficial de MEGA.
 *
 * - Resplandor exterior blanco puro (16px), ciclo de 2.2s con avance en Z de 45px y escala 1.13.
 * - Centrado vertical y horizontal absoluto en viewport y contenedores.
 * - Mensaje en 1 renglón, exactamente 3 palabras, mayúsculas sostenidas, IBM Plex Sans.
 */
export function LoaderMega({
  mensaje,
  pantallaCompleta = false,
  compacto = false,
  ruta,
  className = '',
}: PropsLoaderMega) {
  const fraseFinal = normalizarTresPalabras(mensaje, ruta)

  return (
    <div
      className={`
        ${estilos.contenedor}
        ${pantallaCompleta ? estilos.pantallaCompleta : ''}
        ${compacto ? estilos.compacto : ''}
        ${className}
      `.trim()}
      role="status"
      aria-live="polite"
    >
      <svg
        className={estilos.isotipo}
        viewBox="0 0 512 512"
        role="img"
        aria-label="Cargando sistema MEGA"
        focusable="false"
      >
        <path className={estilos.piezaMorada} d={TRAZO_MORADO} fillRule="evenodd" />
        <path className={estilos.piezaAmarilla} d={TRAZO_AMARILLO} fillRule="evenodd" />
      </svg>

      <p className={estilos.mensaje}>{fraseFinal}</p>
    </div>
  )
}
